import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { CheckoutStepWizardStyled } from '../CheckoutStepWizardStyled';
import media from '../../../styles/media';
import { rem } from 'polished';

export const CheckoutStepWizardAC = styled(CheckoutStepWizardStyled)``;
